import moment from 'moment'
export const getYear = date => {
  let currentDate = moment(date)

  return currentDate.format('YYYY')
}
